import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '4px 4px',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={onClickAction}
    >
      変更
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
